/**
 * CivicPulse — base-path helper.
 *
 * On the canonical apex (civicpulse.blog) routes live at the root:
 *   /            → home
 *   /report      → report wizard
 *   /map         → civic map
 *   /issue/:id   → issue detail
 *
 * On any other host (preview URL, socialpulse.com, etc.) the same
 * app is reached at /civic/*:
 *   /civic       → home
 *   /civic/report
 *   /civic/map
 *   /civic/issue/:id
 *
 * A component that needs to build an internal link should always use
 * `civicPath('/report')` instead of hard-coding either form. The helper
 * reads the persisted preview slug so `?site=civicpulse` on the shared
 * preview URL behaves like the canonical apex too.
 */
export function onCivicApex() {
  if (typeof window === "undefined") return false;
  const host = (window.location.hostname || "").toLowerCase();
  if (host === "civicpulse.blog" || host === "www.civicpulse.blog") return true;
  // Preview override — `?site=civicpulse` latches via sessionStorage
  try {
    const q = new URLSearchParams(window.location.search).get("site");
    if (q) window.sessionStorage.setItem("sp_preview_site", q);
    const latched = window.sessionStorage.getItem("sp_preview_site");
    if ((q || latched) === "civicpulse") return true;
  } catch { /* noop */ }
  return false;
}

export function civicPath(sub = "") {
  const clean = sub.startsWith("/") ? sub : `/${sub}`;
  return onCivicApex() ? (clean === "/" ? "/" : clean) : `/civic${clean === "/" ? "" : clean}`;
}
